import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';

import { selectSortedQueuesByPriorityAndName } from '../../../../app/utils/reselect';
import Queue from '../../components/modals/queue';
import type { FlowChatNodeQueueT } from '../../components/nodeTypes/queue';

export type QueueModalStatePropsT = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (
  state: RootReducerStateT,
  ownProps: { node: FlowChatNodeQueueT },
) => {
  const message = ownProps.node?.payload?.welcome_message
    ? ownProps.node.payload.welcome_message
    : '';

  return {
    queuesState: selectSortedQueuesByPriorityAndName(state),
    initialValues: {
      ...ownProps.node,
      message,
    },
  };
};

export default connect(mapStateToProps)(Queue);
